export default __webpack_public_path__ + "static/media/about-3.c177380d.png";